import React from 'react';
import './styles.css';

export const InstalacionesParrafo = () => {
  return (
    <>
        <div className='InstalacionesParrafo-Principal-Container'>
            
            <div className='instalacionesParrafo-parrafo'>
                La Escuela Infantil Lullaby se ha diseñado basándose en las directrices del método 
                Reggiano-Emilia, con influencias de centros y modelos educativos 
                escandinavos, distribuyéndose el espacio en una sola planta, con 
                ventilación y luz natural, suelos con calefacción radiante, accesos 
                sencillos sin escalones, ni rampas u otros elementos arquitectónicos 
                que impidan su perfecto uso por personas con movilidad reducida, así 
                como patios y jardines que rodean todas las instalaciones, creando un 
                ecosistema de naturaleza e integración visual y paisajística.
            </div>

            <div className='instalacionesParrafo-parrafo'>
                Somos una de las escuelas de la Comunidad de Madrid con mayor 
                superficie disponible por niño, tanto interiores 
                (aulas, salón de usos múltiples, comedor) como exteriores 
                (patios y jardines). Lo que significa que los 42 niños de 
                la Escuela Infantil Lullaby disfrutan de espacios únicos y 
                de los más exclusivos de Madrid.
            </div>
            
        </div>
    </>
  )
}
